import Header from "../../components/Header/Header";
import SideNavbar from "../../components/Navbar/SideNavbar";
import PageMappingList from "../../components/PageMapping/PageMappingList";

const PageMappings = () => {
    return (
        <>
            <div className="flex mainWrapper w-full">
                <div className="sidenav-wrapper">
                    <SideNavbar />
                </div>
                <div className="right-container">
                    <div className="header-container">
                        <Header />
                    </div>
                    <div className="body-container">
                        <PageMappingList />
                    </div>
                </div>
            </div>
        </>
    )
}
export default PageMappings;